// extracted by mini-css-extract-plugin
export var container = "LeftSideSection-module--container--Rvbu5";